<h1 mat-dialog-title>{{ 'dataManagement.directory.dialog.addEditFolder.moveTitle' | transloco }}</h1>

<mat-dialog-content>
  <mat-card class="treeview-container">
    <app-directory-tree 
    [rootFolder]="rootFolder" 
    [includeRecyclingBin]="false" 
    [expandedFolderIds]="expandedFolderIds" 
    (folderActivated)="setSelectedFolder($event)">
    </app-directory-tree>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
  <button [disabled]="isUnreacheable() || !selectedFolder" mat-raised-button color="primary" (click)="acceptChanges()" type="submit">
    {{ 'common.buttons.select' | transloco }}
  </button>
  <button mat-raised-button (click)="discardChanges()" type="button">
    {{ 'common.buttons.cancel' | transloco }}
  </button>
</mat-dialog-actions>
